import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { SkeletonModule } from '@openng/optimus-ui/skeleton'

@Component({
    selector: 'app-client-skeleton-card',
    imports: [SkeletonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './client-skeleton-card.component.html',
})
export class ClientSkeletonCardComponent {
    type = input<'card' | 'list' | 'circle'>('card')
    count = input(1)
}
